<template>
  <div style="padding: 20px; background: rgb(221, 225, 230); border: 1px solid rgb(204, 204, 204)">
    <!-- <v-container fluid class="pa-0 pt-4"> -->
      <!-- El boton "Crear" lo renderiza el propio Modal (tiene activator), asi que para que el de
           importar quede en la misma linea van los dos dentro de un flex. flex-grow-0 evita que el
           v-layout raiz del Modal se coma todo el ancho. -->
      <div class="d-flex align-center">
        <Modal
          v-if="create_access"
          class="flex-grow-0"
          :button_name="'Crear ' + modal_title"
          :modal_title="modal_title"
          :page_title="page_title"
          :formBtn="formBtn"
          :dialog="dialog"
          :service="service"
          @updateDialog="updateDialog"
          @loadList="loadList(service)"
          :editItem="mainItem"
        />

        <v-btn v-if="create_access" outlined class="ml-3 mb-3 btn-third" @click="updateDialogImportExcel(true)">Importar {{ modal_title }}</v-btn>

        <!-- Dispara crons:generar_reposicion (el mismo que corre solo a las 01:00) para todos
             los almacenes. Corre en background: :loading/:disabled reflejan tanto el request
             de disparo como el polling mientras el proceso sigue corriendo del lado del server. -->
        <v-btn
          v-if="create_access"          
          color="blue-grey"
          dark
          prepend-icon="mdi-sync"
          class="ml-auto mb-3"
          :loading="loading_reposicion || reposicion_running"
          :disabled="loading_reposicion || reposicion_running"
          @click="confirmGenerarReposicion"
        >
          {{ reposicion_running ? "Generando reposición..." : "Generar reposición" }}
        </v-btn>
      </div>

      <DialogYesNo
        :open="dialog_generar_reposicion"
        title="Generar reposición"
        message="¿Confirma iniciar la generación de tareas de reposición para todos los almacenes? El proceso corre en segundo plano y puede tardar varios minutos."
        :loading="loading_reposicion"
        @cancel="closeGenerarReposicionDialog"
        @accept="generarReposicion"
      />

      <ModalImportExcel
        v-if="create_access"
        :button_name="'Importar ' + modal_title"
        :modal_title="'Importar ' + modal_title"
        :page_title="page_title"
        formBtn="Importar"
        :dialog="dialog_import_excel"
        :service="service"
        @updateDialog="updateDialogImportExcel"
        @loadList="loadList(service)"
      />

      <!-- Las dos leyendas comparten renglon: el horario del cron a la izquierda y el resultado
           de la ultima corrida a la derecha (justo debajo del boton que la dispara). -->
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="text-caption text-grey-darken-1">
          <v-icon size="small" class="mr-1">mdi-clock-outline</v-icon>
          El proceso de creación de tareas de reposición corre todos los días a la 1 AM
        </span>

        <!-- Resultado de la ultima corrida (la manual y la del cron de la 01:00 comparten cache).
             Va aparte del toast: el toast se pierde a los segundos y solo lo ve quien disparo el
             proceso, asi que el que entra despues a la pantalla no tenia forma de saber como
             termino la ultima generacion. -->
        <span
          v-if="reposicion_last_result"
          class="text-caption text-right ml-4"
          :class="reposicion_last_result.ok ? 'text-green-darken-2' : 'text-red-darken-2'"
        >
          <v-icon size="small" class="mr-1">{{ reposicion_last_result.ok ? "mdi-check-circle-outline" : "mdi-alert-circle-outline" }}</v-icon>
          Última generación ({{ reposicion_last_result.finished_at }}): {{ reposicion_last_result.msg }}
        </span>
      </div>

      <!-- Filtros -->
      <v-card class="mb-4" v-if="list_access">
        <div class="row mb-2 ps-3 pe-3 mt-0 mb-2">
          <div class="col-md-12">
            <div class="col-md-12" style="background: white">
              <p class="text-h6 mt-2 mb-0"><font-awesome-icon icon="filter" class="pr-2" />Filtros</p>
              <v-divider class="mt-0"></v-divider>

              <div class="row pt-2">
                <div class="col-md-3" v-if="!isClient()">
                  <v-combobox v-model="filters.client" density="comfortable" item-title="name" item-value="id" :items="clients" label="Cliente" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-combobox v-model="filters.almacen" density="comfortable" item-title="name" item-value="id" :items="almacenes" label="Almacén" autocomplete="off" clearable></v-combobox>
                </div>
                <div class="col-md-3">
                  <v-text-field v-model="filters.ubicacion_code" density="comfortable" label="Ubicación" autocomplete="off" clearable @keyup.enter="loadList(service)"></v-text-field>
                </div>

                <div class="col-md-3 pt-2" style="display: flex; justify-content: end">
                  <v-btn color="info" @click="loadList(service)" prepend-icon="mdi-magnify">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Tabla -->
      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3">
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item, index }">
            <tr>
              <td>
                <v-icon size="small" class="mr-1" @click="toggleExpand(index)">
                  {{ isExpanded(index) ? "mdi-chevron-down" : "mdi-chevron-right" }}
                </v-icon>
                {{ item.product ? item.product.label : "-" }}
              </td>
              <td v-if="!isClient()">{{ item.client ? item.client.name : "-" }}</td>
              <td>{{ item.almacen ? item.almacen.name : "-" }}</td>
   
              <td class="text-center">{{ item.stock_min }}</td>
              <td class="text-center">
                {{ item.stock_max }}
                <!-- <v-tooltip bottom v-if="item.stock_max_below_pallet">
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" color="warning" size="small" class="ml-1">mdi-alert</v-icon>
                  </template>
                  <span>
                    El máximo ({{ item.stock_max }}) es menor a un pallet ({{ item.units_per_pallet }}). Si una ubicación queda vacía se baja el pallet entero y se pasa del máximo.
                  </span>
                </v-tooltip> -->
              </td>
              <td>
                <v-chip :color="item.activo ? 'green' : 'red'" size="small">
                  {{ item.activo ? "Activa" : "Inactiva" }}
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="update_access" v-bind="props" small color="blue" class="mr-2" v-on:click="editItem(item)" size="small"> mdi-pencil</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-bind="props" small color="blue" class="mr-2" v-on:click="viewItem(item)" size="small"> mdi-eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ props }">
                    <v-icon v-if="delete_access" v-bind="props" small color="red" class="mr-2" v-on:click="deleteItem(item)" size="small">mdi-delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
            <tr v-if="isExpanded(index)">
              <td :colspan="headers.length" class="pa-0">
                <v-table density="compact" class="bg-grey-lighten-4">
                  <thead>
                    <tr>
                      <th class="text-left">Ubicación</th>
                      <th class="text-left">Zona</th>
                      <th class="text-left">Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="location in item.locations" :key="location.id">
                      <td>{{ location.ubicacion ? location.ubicacion.code : "-" }}</td>
                      <td>{{ location.ubicacion && location.ubicacion.zona ? location.ubicacion.zona.name : "-" }}</td>
                      <td>{{ location.ubicacion && location.ubicacion.tipo_ubicacion ? location.ubicacion.tipo_ubicacion.name : "-" }}</td>
                    </tr>
                  </tbody>
                </v-table>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" :loading="loadingSubmit" />
    <!-- </v-container> -->
  </div>
</template>

<script>
import { reposicionRuleService } from "@/libs/ws/reposicionRuleService";
import { almacenService } from "@/libs/ws/almacenService";
import { clientService } from "@/libs/ws/clientService";
import Constant from "@/constants/sections";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Modal from "./ReposicionRuleModal.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import DialogYesNo from "@/components/DialogYesNo.vue";

export default {
  components: { Modal, ModalImportExcel, DialogYesNo },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      rol_section: Constant.SECTION_RULES,
      service: reposicionRuleService,
      page_title: "Reglas de Reposicion",
      modal_title: "Regla de Reposicion",
      almacenes: [],
      clients: [],
      dialog_import_excel: false,
      dialog_generar_reposicion: false,
      loading_reposicion: false, //true mientras se dispara el proceso (POST inicial)
      reposicion_running: false, //true mientras el proceso sigue corriendo del lado del server
      reposicion_last_result: null, //resultado de la ultima corrida, se muestra debajo del boton
      checking_reposicion_estado: false, //evita solapar polls si uno anterior no respondio
      reposicion_poll_interval: null,
      filters: {
        client: null,
        almacen: null,
        ubicacion_code: "",
      },
      headers: [
        {
          title: "Producto",
          align: "left",
          sortable: true,
          key: "product.label",
        },
        {
          title: "Cliente",
          align: "left",
          sortable: true,
          key: "client.name",
          visible_for_client: false,
        },
        {
          title: "Almacén",
          align: "left",
          sortable: true,
          key: "almacen.name",
        },
        {
          title: "Stock mínimo",
          align: "center",
          sortable: true,
          key: "stock_min",
        },
        {
          title: "Stock máximo",
          align: "center",
          sortable: true,
          key: "stock_max",
        },
        {
          title: "Estado",
          align: "left",
          sortable: true,
          key: "activo",
        },
        { title: "Accion", align: "center", sortable: false, key: "" },
      ],
    };
  },
  mounted() {
    this.loadAlmacenes();
    if (!this.isClient()) this.loadClients();

    //Saco la columna Cliente para el usuario cliente: el listado ya viene filtrado a lo suyo.
    this.headers = this.headers.filter((header) => {
      if (header.visible_for_client || header.visible_for_client == undefined) {
        return true;
      }
      return !this.isClient();
    });

    this.loadList(this.service);

    //Puede haber una corrida en curso disparada por otro usuario, o por el cron de la 01:00:
    //si es asi, el boton arranca deshabilitado y el polling sigue el proceso hasta que termine.
    this.checkReposicionEstadoInicial();
  },
  beforeUnmount() {
    this.stopPollingReposicionEstado();
  },
  methods: {
    updateDialogImportExcel(value) {
      this.dialog_import_excel = value;
    },
    getFilterParams() {
      var param = {};
      if (this.filters.client && this.filters.client.id) param.client = { id: this.filters.client.id };
      if (this.filters.almacen && this.filters.almacen.id) param.almacen = { id: this.filters.almacen.id };
      if (this.filters.ubicacion_code) param.ubicacion_code = this.filters.ubicacion_code;
      // La tabla pagina del lado del cliente: se pide el listado completo
      param.limit = 0;
      return param;
    },
    loadAlmacenes() {
      almacenService.filter({}).then((response) => {
        this.almacenes = response.result.list;
        //Si hay un unico almacen disponible, se preselecciona y se re-filtra la lista con el
        if (this.almacenes.length === 1 && this.filters.almacen == null) {
          this.filters.almacen = this.almacenes[0];
          this.loadList(this.service);
        }
      });
    },
    loadClients() {
      clientService
        .filter({})
        .then((response) => {
          this.clients = response.result.list;
        })
        .catch((e) => {
          console.log("clientService.filter error", e);
        });
    },
    confirmGenerarReposicion() {
      if (this.reposicion_running) return; //el boton ya deberia estar deshabilitado, doble resguardo
      this.dialog_generar_reposicion = true;
    },
    closeGenerarReposicionDialog() {
      this.dialog_generar_reposicion = false;
    },
    generarReposicion() {
      if (this.loading_reposicion || this.reposicion_running) return; //guard de reentrada
      this.loading_reposicion = true;

      this.service
        .generar_reposicion()
        .then((response) => {
          if (response.status) {
            this.toast.success(response.msg);
            this.reposicion_running = true;
            this.startPollingReposicionEstado();
          } else {
            this.toast.error(response.msg);
          }
        })
        .catch((e) => {
          this.toast.error(e);
        })
        .finally(() => {
          this.loading_reposicion = false;
          this.dialog_generar_reposicion = false;
        });
    },
    checkReposicionEstadoInicial() {
      this.service.generar_reposicion_estado().then((response) => {
        if (!response.status) return;

        this.reposicion_last_result = response.result.last_result;

        if (response.result.running) {
          this.reposicion_running = true;
          this.startPollingReposicionEstado();
        }
      });
    },
    startPollingReposicionEstado() {
      this.stopPollingReposicionEstado(); //por si quedo uno viejo corriendo
      this.reposicion_poll_interval = setInterval(() => {
        this.checkReposicionEstado();
      }, 5000);
    },
    stopPollingReposicionEstado() {
      if (this.reposicion_poll_interval) {
        clearInterval(this.reposicion_poll_interval);
        this.reposicion_poll_interval = null;
      }
    },
    checkReposicionEstado() {
      if (this.checking_reposicion_estado) return; //no solapar si la respuesta anterior no llego
      this.checking_reposicion_estado = true;

      this.service
        .generar_reposicion_estado()
        .then((response) => {
          if (!response.status) return;

          var termino = this.reposicion_running && !response.result.running;
          this.reposicion_running = response.result.running;
          this.reposicion_last_result = response.result.last_result;

          if (!this.reposicion_running) {
            this.stopPollingReposicionEstado();
            if (termino) this.showReposicionResult(response.result.last_result);
            this.loadList(this.service);
          }
        })
        .finally(() => {
          this.checking_reposicion_estado = false;
        });
    },
    showReposicionResult(last_result) {
      //Sin last_result (ej: el proceso murio antes de poder persistir el resultado, como un
      //fallo de permisos en storage) el usuario se quedaba sin feedback: el boton dejaba de
      //girar y no pasaba nada mas.
      if (!last_result) {
        this.toast.error("La generación de reposición terminó sin reportar un resultado. Revise el log del servidor.");
        return;
      }

      if (last_result.ok) this.toast.success("Generación de reposición finalizada. " + last_result.msg);
      else this.toast.error("Generación de reposición finalizada con errores. " + last_result.msg);
    },
  },
};
</script>
